module.exports = __webpack_public_path__ + "img/brand-babel.e75db399.svg";